import React, { Component } from 'react';
import firebase from 'firebase';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

import DataTableComponent from '../../admin/core/DataTableComponent';
import CurrentUser from "../core/PublicUserSessionContext";
import CKEditor from '@ckeditor/ckeditor5-react';
import Spinner from "../../commons/Spinner";
import UploadFileAlertComponent from '../../admin/core/UploadFileAlertComponent';
import DatePicker from 'react-date-picker';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Carousel from 'react-simply-carousel';
import AulaItemComponent from './AulaItemComponent';

import logoBlanco from '../../../resources/images/logo-blanco.png'
import { userCanAccessAula } from '../../../utils/aula.utils';
import { 
  FILTER_ALL, 
  FILTER_UNIVERSITIES, 
  FILTER_COMPANIES, 
  FILTER_ORGANIZATIONS,
  FILTER_TYPE_ALL,
  FILTER_TYPE_ORGANIZATION,
  UNIVERSIDAD,
  EMPRESA
} from '../../../service/constants';

class AulaGridComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      allDiplomados: [],
      allOrganizations: [],
      activeFilterType: FILTER_TYPE_ALL,
      activeOrganizationId: null,
      principalOrganization: null,
      universities: [],
      companies: [],
      hasCxVet: false,
      allAulas: [],
    }
  }


  componentDidMount = () => {
    const db = firebase.firestore();
    let allOrganizations = []
    let universities = []
    let companies = []
    let principalOrganization = null

    db.collection('aulas').where("active", "==", true).get().then((aulaColl) => {
      let allAulas = aulaColl.docs.map((doc) => { return { id: doc.id, ...doc.data() } });

      db.collection('organizations').get().then((organizationsColl) => {

        organizationsColl.docs.forEach((organization) => {
          let orgData = { id: organization.id, ...organization.data() }
          let orgAulas = []

          allAulas.forEach((aula) => {
            if (aula.organization === organization.id && aula.date_expiration > Date.now()) {
              orgAulas.push(aula)
            }
          })

          if (orgAulas.length !== 0) {
            let orgWithAulas = { ...orgData, aulas: orgAulas }
            allOrganizations.push(orgWithAulas)

            if (orgData.isCxVetOrg === true && !principalOrganization) {
              principalOrganization = orgWithAulas
            }

            if (orgData.type === UNIVERSIDAD) {
              universities.push(orgWithAulas)
            } else if (orgData.type === EMPRESA) {
              companies.push(orgWithAulas)
            }
          }
        })

        this.setState({ 
          allOrganizations, 
          universities,
          companies,
          principalOrganization,
          loading: false 
        })

      }).catch(error => {
        console.log(error)
        this.setState({ loading: false })
      })

    }).catch(error => {
      console.log(error)
      this.setState({ loading: false })
    })

  }

  getAulasForFilter = () => {
    const { activeFilterType, activeOrganizationId, allOrganizations } = this.state

    if (activeFilterType === FILTER_TYPE_ORGANIZATION && activeOrganizationId) {
      const org = allOrganizations.find(o => o.id === activeOrganizationId)
      return org ? org.aulas : []
    }
    return []
  }

  getAulasUniversities = () => {
    return this.state.universities.reduce((acc, org) => [...acc, ...org.aulas], [])
  }

  getAulasCompanies = () => {
    return this.state.companies.reduce((acc, org) => [...acc, ...org.aulas], [])
  }

  getActiveOrganization = () => {
    if (this.state.activeFilterType === FILTER_TYPE_ORGANIZATION && this.state.activeOrganizationId) {
      return this.state.allOrganizations.find(o => o.id === this.state.activeOrganizationId)
    }
    return null
  }

  handleFilterChange = (filterType, organizationId = null) => {
    this.setState({
      activeFilterType: filterType,
      activeOrganizationId: organizationId
    })
  }

  render() {
    const { activeFilterType, activeOrganizationId, principalOrganization, allOrganizations } = this.state
    const currentUser = this.context.currentUser
    const activeOrg = this.getActiveOrganization()
    
    let logoImageURL = null
    let orgTitle = ""
    let showBanner = false

    if (activeFilterType === FILTER_TYPE_ORGANIZATION && activeOrg) {
      logoImageURL = activeOrg.logoImageURL
      orgTitle = activeOrg.title
      showBanner = activeOrg.private === true
    } else if (activeFilterType === FILTER_TYPE_ALL) {
      if (principalOrganization) {
        logoImageURL = principalOrganization.logoImageURL
        orgTitle = principalOrganization.title
      }
    }

    const aulasUniversities = this.getAulasUniversities()
    const aulasCompanies = this.getAulasCompanies()

    return (
      <section className="video-grid">
        <div className="container">

          {showBanner && activeOrg && <a href={"https://" + activeOrg.promoLink} target="_blank"> <section className="about-intro intro bg-secondary aula-banner" style={{  backgroundImage: `url(${activeOrg.promoImageURL})` }} >
          </section></a>}

          <div className="row ">
            <div className="col-md-12">

              <div className="video-title-bar d-md-flex justify-content-between">

                <h1 className="main-title">
                  Mis Aulas
                </h1>

                <div>
                  <div className="mb-3 p-0 row no-gutters align-items-center">
                    <div className="col">
                      {//<input onChange={this.searchByName} className="form-control form-control-borderless" type="search" placeholder="Buscar en catálogo" />
                      }
                    </div>
                    <div className="col-auto pl-3 pr-3">
                      <a>
                        {//<FontAwesomeIcon icon={faSearch} />
                        }
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-5 col-12" >

                  {logoImageURL && <img className="img-fluid  mb-2 preview" src={logoImageURL} />}
                  {orgTitle && <h1 className="main-title">
                    {orgTitle}
                  </h1>}
                  <div className=" filter-sidebar">

                    <span className="h4">{FILTER_ORGANIZATIONS}</span>
                    
                    <ul className="list-unstyled pl-3">
                      <li className={activeFilterType === FILTER_TYPE_ALL ? "Gratis active" : "Gratis"}>
                        <button onClick={() => this.handleFilterChange(FILTER_TYPE_ALL)}>{FILTER_ALL}</button>
                      </li>
                      {allOrganizations.map(organization => {
                        const isActive = activeFilterType === FILTER_TYPE_ORGANIZATION && activeOrganizationId === organization.id
                        return (
                          <li key={organization.id} className={isActive ? "Gratis active" : "Gratis"}>
                            <button onClick={() => this.handleFilterChange(FILTER_TYPE_ORGANIZATION, organization.id)}>
                              {organization.title}
                            </button>
                          </li>
                        )
                      })}
                    </ul>

                  </div>
                </div>
                <div className="col-lg-9 col-md-8 col-sm-7 col-12" >
                  <div className="row">
                    {activeFilterType === FILTER_TYPE_ALL ? (
                      <>
                        {aulasUniversities.length > 0 && (
                          <>
                            <div className="col-12">
                              <h2 className="main-title mb-3">{FILTER_UNIVERSITIES}</h2>
                            </div>
                            {aulasUniversities.map(aula => {
                              return (
                                <AulaItemComponent 
                                  key={aula.id} 
                                  previewImageURL={aula.previewImageURL} 
                                  title={aula.title} 
                                  description={aula.description} 
                                  link={userCanAccessAula(currentUser.id, aula) ? `/mis-aulas/aula/${aula.id}` : aula.previewPdfURL} 
                                />
                              )
                            })}
                          </>
                        )}
                        {aulasCompanies.length > 0 && (
                          <>
                            <div className="col-12">
                              <h2 className="main-title mb-3 mt-4">{FILTER_COMPANIES}</h2>
                            </div>
                            {aulasCompanies.map(aula => {
                              return (
                                <AulaItemComponent 
                                  key={aula.id} 
                                  previewImageURL={aula.previewImageURL} 
                                  title={aula.title} 
                                  description={aula.description} 
                                  link={userCanAccessAula(currentUser.id, aula) ? `/mis-aulas/aula/${aula.id}` : aula.previewPdfURL} 
                                />
                              )
                            })}
                          </>
                        )}
                      </>
                    ) : (
                      this.getAulasForFilter().map(aula => {
                        return (
                          <AulaItemComponent 
                            key={aula.id} 
                            previewImageURL={aula.previewImageURL} 
                            title={aula.title} 
                            description={aula.description} 
                            link={userCanAccessAula(currentUser.id, aula) ? `/mis-aulas/aula/${aula.id}` : aula.previewPdfURL} 
                          />
                        )
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Spinner show={this.state.loading} />
      </section>
    );
  }
}
AulaGridComponent.contextType = CurrentUser;
export default AulaGridComponent